module.exports = __webpack_public_path__ + "img/growcify-pos-payment-link-banner.808f5df4.png";